import {map, mergeMap} from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TenantService, UserService } from '.'
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(private userService:UserService, private tenantService: TenantService, private router:Router) { }
    
    
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.userService.isLoggedIn()
        .pipe(
            mergeMap(status => of(!!status.user)),
            mergeMap(isLoggedIn => isLoggedIn ? of(null) : this.tenantService.getUnauthTenantInfo()),
            map((tenant) => {
                if(!tenant) { // already authenticated
                    return true;
                } else if (tenant.settings?.publicTopics !== 'true' || route.data?.ignorePublicTopics) { 
                    // not authed and not a public tennant
                    return this.router.createUrlTree(['/login'], {queryParams: _.assign({originator: state.url}, state.root.queryParams)});
                } else if (state.url.startsWith('/browse')) { // public tenant and trying to hit browse
                    return true;
                } else { // public tenant and trying to hit something else
                    return this.router.createUrlTree(['/browse'], {queryParams: _.assign({originator: state.url}, state.root.queryParams)});
                }
            })
        );
    }
}
